/**
 * services/_tokens.js — shared visual tokens for the Photobooth Hire
 * commercial vertical.
 *
 * These match the existing editorial memory-platform palette (walnut
 * + ivory + gold) so the two surfaces feel like the same brand. The
 * COMMERCIAL section uses SLIGHTLY brighter accents (full GOLD on
 * buttons, more saturated CTAs) because it's a booking surface —
 * the editorial pages stay quieter on purpose.
 */
export const SERIF = 'Georgia, "Cormorant Garamond", "Times New Roman", serif';
export const SANS  = "'Inter', system-ui, sans-serif";

export const IVORY        = '#FBEED0';
export const IVORY_DIM    = 'rgba(251,238,208,0.72)';
export const IVORY_GHOST  = 'rgba(251,238,208,0.48)';
export const IVORY_FAINT  = 'rgba(251,238,208,0.30)';

export const GOLD         = '#D4AF5E';
export const GOLD_BRIGHT  = '#E8C175';
export const GOLD_MUTED   = 'rgba(212,170,82,0.78)';
export const GOLD_FAINT   = 'rgba(212,170,82,0.22)';
export const GOLD_HAIRLINE = 'rgba(212,170,82,0.14)';

export const WALNUT       = '#0E0805';
export const WALNUT_ALT   = '#120A06';
export const WALNUT_DEEP  = '#080503';
export const WALNUT_CARD  = 'rgba(20,12,6,0.72)';

export const PAGE_BG = `radial-gradient(1200px 800px at 50% -100px, ${WALNUT_ALT} 0%, ${WALNUT} 60%, ${WALNUT_DEEP} 100%)`;

export const PILL_BUTTON_PRIMARY = {
  display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 8,
  padding: '14px 28px',
  borderRadius: 999,
  background: `linear-gradient(135deg, ${GOLD_BRIGHT} 0%, ${GOLD} 100%)`,
  color: '#0F0B1A',
  border: 'none',
  fontFamily: SERIF, fontWeight: 700, fontSize: 14.5,
  letterSpacing: '0.04em',
  cursor: 'pointer',
  boxShadow: '0 10px 30px rgba(0,0,0,0.35)',
  textDecoration: 'none',
  transition: 'transform 240ms ease, box-shadow 240ms ease',
};

export const PILL_BUTTON_GHOST = {
  display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 8,
  padding: '14px 26px',
  borderRadius: 999,
  background: 'transparent',
  color: IVORY,
  border: `1px solid ${GOLD_FAINT}`,
  fontFamily: SERIF, fontStyle: 'italic', fontWeight: 500, fontSize: 14,
  letterSpacing: '0.04em',
  cursor: 'pointer',
  textDecoration: 'none',
  transition: 'border-color 240ms ease, background 240ms ease',
};

export const CARD = {
  background: WALNUT_CARD,
  border: `1px solid ${GOLD_HAIRLINE}`,
  borderRadius: 8,
  boxShadow: '0 16px 60px rgba(0,0,0,0.45), inset 0 1px 0 rgba(212,170,82,0.06)',
};

// Geographic regions — order matches Craig's iter217 priority.
export const COVERAGE_REGIONS = [
  'Wrexham',
  'North Wales',
  'Cheshire',
  'Shropshire',
  'Wirral',
  'Liverpool',
  'Merseyside',
  'Manchester',
  'Lancashire',
];

export const COVERAGE_TAGLINE =
  'Photobooth Hire Across North Wales, Cheshire, Shropshire & The North West';
